// ----------------------------------------------------------------------

export const bank = [
  'Lueilwitz and Sons',
  'Gleichner, Mueller and Tromp',
  'Nikolaus - Leuschke',
  'Hegmann, Kreiger and Bayer',
  'Grimes Inc',
  'Durgan - Murazik',
  'Altenwerth, Medhurst and Roberts',
  'Raynor Group',
  'Mraz, Donnelly and Collins',
  'Padberg - Bailey',
  'Heidenreich, Stokes and Parker',
  'Pagac and Sons',
  'Rempel, Hand and Herzog',
  'Dare - Treutel',
  'Kihn, Marquardt and Crist',
  'Nolan - Kunde',
  'Wuckert Inc',
  'Dibbert Inc',
  'Goyette and Sons',
  'Feest Group',
  'Bosco and Sons',
  'Bartell - Kovacek',
  'Schimmel - Raynor',
  'Tremblay LLC',
  'Hills - Mitchell',
  'Rogahn LLC',
  'Kuhn, Osinski and Morar',
  'Schmitt Inc',
  'Breitenberg - Rosenbaum',
  "O'Keefe, Schneider and Mraz",
  'Rohan, Langworth and Kling',
  'Morar and Sons',
  'Mraz LLC',
  'Rowe, Parisian and Kub',
  'Marquardt - Hane',
  'Medhurst Group',
  'Nikolaus - Lang',
  'Effertz, Mohr and Olson',
  'Anderson - Kris',
  'Runolfsson Group'
];
